import React, { useState } from "react";
import "../../assets/css/envoiEmail.css";
import { useTranslation } from "react-i18next";
import Modal from "react-modal"; // Importez le composant Modal

const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "#f8f9fa",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        textAlign: "center",
    },
    overlay: {
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        zIndex: 1000,
    },
};

Modal.setAppElement("#root"); // Liez le modal à l'élément racine de votre application

const BulkEmailForm = () => {
    const [subject, setSubject] = useState("");
    const [body, setBody] = useState("");
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [isError, setIsError] = useState(false);

    const { t } = useTranslation("admin");

    const openModal = (message, isError = false) => {
        setModalMessage(message);
        setIsError(isError);
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setModalMessage("");
        setIsError(false);
    };
    const API_BASE_URL = process.env.REACT_APP_API_URL;
    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            const response = await fetch(
                `${API_BASE_URL}/api/admin/send-bulk`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem(
                            "adminToken"
                        )}`,
                    },
                    body: JSON.stringify({ subject, body }),
                }
            );

            const data = await response.json();

            if (response.ok) {
                openModal(t("bulkEmail.successMessage"));
                setSubject("");
                setBody("");
            } else {
                openModal(data.message || t("bulkEmail.errorMessage"), true);
            }
        } catch (err) {
            console.error(t("bulkEmail.fetchError"), err);
            openModal(t("bulkEmail.fetchError"), true);
        }
    };

    return (
        <div className="bulk-email-form">
            <h2>{t("bulkEmail.title")}</h2>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="subject">
                        {t("bulkEmail.subjectLabel")}:
                    </label>
                    <input
                        type="text"
                        id="subject"
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="body">{t("bulkEmail.bodyLabel")}:</label>
                    <textarea
                        id="body"
                        value={body}
                        onChange={(e) => setBody(e.target.value)}
                        rows="5"
                        required
                    />
                </div>
                <button type="submit">{t("bulkEmail.sendButton")}</button>
            </form>

            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel={
                    isError ? t("modal.errorTitle") : t("modal.successTitle")
                }
            >
                <h2>
                    {isError ? t("modal.errorTitle") : t("modal.successTitle")}
                </h2>
                <p>{modalMessage}</p>
                <button onClick={closeModal}>{t("modal.closeButton")}</button>
            </Modal>
        </div>
    );
};

export default BulkEmailForm;
